export const PROFILE_LICENSURES_ERROR = 'PROFILE_LICENSURES_ERROR';
export const PROFILE_LICENSURES_LOADING = 'PROFILE_LICENSURES_LOADING';
export const PROFILE_LICENSURES_SUCCESS = 'PROFILE_LICENSURES_SUCCESS';